import styled from 'styled-components';
import { FormControl } from '@material-ui/core';

// CONSTANTS
import { ATHENS_GRAY, MAIN_BLACK, SANTAS_GRAY, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const StyledCreditCard = styled(FormControl)`
  .credit-card__label {
    color: ${MAIN_BLACK};

    margin-bottom: 16px;

    ${breakpoints.up('md')} {
      margin-bottom: 8px;
    }
  }

  .credit-card-form {
    background-color: ${ATHENS_GRAY};
    border-radius: 16px;
    padding: 24px;

    .MuiInputBase-root {
      background-color: ${WHITE};
    }

    ${breakpoints.up('md')} {
      padding: 32px;
    }

    &__save {
      .save {
        display: flex;
        align-items: flex-start;

        margin-left: 2px;

        .MuiFormLabel-root {
          color: inherit;
        }

        .info-icon {
          color: ${SANTAS_GRAY};

          width: 20px;
          height: 20px;
        }

        .save {
          &__label {
            color: inherit;
            align-items: flex-start;

            .MuiFormControlLabel-label {
              margin-right: 10px;
              margin-left: 10px;
            }

            .MuiCheckbox-root {
              i {
                font-size: 12px;

                &:before {
                  width: 14px;
                  height: 14px;
                  border-width: 2px;
                }
              }
            }

            .Mui-checked + .MuiFormControlLabel-label {
              color: inherit;
            }

            &.save__label--error {
              .MuiCheckbox-root i:before {
                border-color: ${({ theme }) => theme.palette.error.main};
              }
            }
          }
        }
      }
    }

    .cancel-change-btn {
      padding: 11px;
      margin-top: 20px;
      margin-left: -11px;
    }
  }

  .credit-card-placeholder {
    position: relative;
    display: flex;
    justify-content: space-between;

    background-color: ${ATHENS_GRAY};
    border-radius: 16px;
    padding: 24px;

    .bank-name {
      margin-top: 4px;
      color: ${SANTAS_GRAY};
    }

    .MuiButton-root {
      padding: 11px;
      margin-right: -11px;
      margin-left: -11px;
    }

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__title {
      height: 1em;
      white-space: nowrap;
      display: flex;
      align-items: center;

      .brand-icon {
        height: 1.5em;
        margin-left: 5px;
        vertical-align: middle;
      }
    }

    ${breakpoints.up('md')} {
      padding: 32px;

      .MuiButton-root {
        position: absolute;
        top: 5px;
        right: 5px;
        margin: 0;
      }
    }
  }
`;

export default StyledCreditCard;
